import * as React from 'react';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiPopper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Grid": Grid, "@mui/material/Typography": Typography, "@mui/material/Box": Box, "@mui/material/Button": Button, "@mui/material/Popper": MuiPopper, "@mui/material/Paper": Paper, "@mui/material/DialogActions": DialogActions, "@mui/material/DialogContent": DialogContent, "@mui/material/DialogContentText": DialogContentText, "@mui/material/DialogTitle": DialogTitle, "@mui/material/Switch": Switch, "@mui/material/TextField": TextField, "@mui/material/FormGroup": FormGroup, "@mui/internal-core-docs/HighlightedCode": { HighlightedCode } } } });
export default ClientProvider;
